module.exports = __webpack_public_path__ + "img/paul-smc.57c17384.jpg";